// src/packages/chubb/travel/chubb_travel_international/index.js
import ChubbTravelCard from "./ChubbTravelCard";
import ChubbTravelDetails from "./ChubbTravelDetails";
import "./chubb_travel.css";

/**
 * Chubb — Travel Insurance International (Single Trip)
 * แพ็กเกจท่องเที่ยวต่างประเทศ (ทริปเดียว) คุ้มครองครบ: รักษาพยาบาล, อพยพฉุกเฉิน,
 * กระเป๋า/ทรัพย์สิน, เที่ยวบินล่าช้า/ยกเลิก, ความรับผิดต่อบุคคลภายนอก ฯลฯ
 */
export default {
  id: "chubb_travel_international_singletrip",
  company: "ชับบ์ (Chubb)",   // ให้ตรงกับ COMPANY_INFO
  productLine: "travel",
  categories: ["travel", "international"],
  nameTH: "Chubb Travel International (Single Trip)",
  description: "ประกันเดินทางต่างประเทศ ครบทั้งค่ารักษา อพยพฉุกเฉิน กระเป๋า และเที่ยวบิน",
  accent: "#0ea5e9",          // ถ้ามี accent ใน COMPANY_INFO จะ override
  expiresAt: "9999-12-31",
  card: ChubbTravelCard,
  detail: ChubbTravelDetails,
  active: true,
};
